// extracted by mini-css-extract-plugin
export default {"container":"rating_container__CS7GM"};